'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Цаг сонгох'
};

exports['default'] = locale;